/**
 * Ограничения вложений — одни на портал (ADR 0013, ADR 0024).
 *
 * Раньше эти же числа лежали копиями в каждой форме с загрузкой, и «до 50 МБ» в подписи поля
 * ничем не было связано с проверкой рядом: разойтись они могли молча.
 */

/** Предел размера одного файла: 50 МБ. */
export const FILE_MAX_SIZE = 52_428_800;

/** Сколько файлов принимает одна заявка. */
export const FILE_MAX_COUNT = 20;

/** Подпись для поля загрузки: числа те же, что и в проверках. */
export const fileLimitsHint = `до ${FILE_MAX_COUNT}, до ${FILE_MAX_SIZE / 1024 / 1024} МБ каждый`;
